import { StyledPopup } from './styles';

const Tooltip = ({ triggerComponent, contentComponent }) => (
  <StyledPopup
    trigger={triggerComponent}
    position='top right'
    on={['hover', 'focus']}
    closeOnDocumentClick>
    {contentComponent}
  </StyledPopup>
);

export default Tooltip;
